import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-reports-home',
    imports: [RouterModule],
    templateUrl: './reports-home.component.html',
    styleUrl: './reports-home.component.scss'
})
export class ReportsHomeComponent {

}
